/* One-click fabric swatches (snippets/lx-swatch.liquid). A click adds one swatch line to the cart: the swatch product
   (Theme settings → Luxire — swatches) at $1, with the fabric's name, mill and picture as line properties. A fabric
   already in the cart shows "in your cart". The cart (snippets/cart-drawer, sections/luxire-cart) lists swatch lines
   together, under "Swatches". Once an order is paid, the server emails a gift card for its swatches.
   LXSwatch.addAll(elements) orders several at once (the fabric comparison); 'lx:swatches' fires when the cart changes. */
(function (w, d) {
  var inCart = {};   // fabric handle → in the cart
  var busy = {};

  function els(handle) {
    return Array.prototype.filter.call(d.querySelectorAll('[data-lx-sw]'), function (el) { return el.getAttribute('data-handle') === handle; });
  }
  function say(el, text) {  // a message beside the button, read out by screen readers
    var n = el.querySelector('[data-lx-sw-msg]');
    if (n) n.textContent = text;
  }
  function mark(handle, on) {
    inCart[handle] = !!on;
    els(handle).forEach(function (el) { el.classList.toggle('is-added', !!on); el.classList.remove('is-busy'); });
  }
  function changed() {
    try { d.dispatchEvent(new CustomEvent('lx:swatches')); } catch (e) { /* very old browsers */ }
  }
  function isSwatch(item) { return !!(item && item.properties && item.properties._swatch_of); }
  /** Buttons follow the cart: called with each cart the page reads. */
  function sync(cart) {
    var now = {};
    ((cart && cart.items) || []).forEach(function (it) { if (isSwatch(it)) now[it.properties._swatch_of] = true; });
    Object.keys(inCart).concat(Object.keys(now)).forEach(function (h) { mark(h, !!now[h]); });
    changed();
  }
  function itemOf(el) {
    var handle = el.getAttribute('data-handle');
    var props = { 'Fabric': el.getAttribute('data-title') || handle, '_swatch_of': handle };
    if (el.getAttribute('data-mill')) props['Mill'] = el.getAttribute('data-mill');
    if (el.getAttribute('data-image')) props['_swatch_image'] = el.getAttribute('data-image');
    return { id: Number(el.getAttribute('data-variant')), quantity: 1, properties: props };
  }
  /** Adds the swatches of these fabrics (one request); those already in the cart are left out. */
  function addAll(list) {
    var seen = {};
    list = list.filter(function (el) {
      var h = el && el.getAttribute('data-handle');
      if (!h || seen[h] || busy[h] || inCart[h]) return false;
      return (seen[h] = true);
    });
    if (!list.length) return Promise.resolve(false);
    var handles = list.map(function (el) { return el.getAttribute('data-handle'); });
    handles.forEach(function (h) { busy[h] = true; els(h).forEach(function (x) { x.classList.add('is-busy'); say(x, ''); }); });
    return fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: list.map(itemOf) })
    }).then(function (r) {
      if (r.ok) return r.json();
      return r.json().catch(function () { return {}; }).then(function (b) { throw new Error((b && b.description) || ''); });
    }).then(function () {
      handles.forEach(function (h) { busy[h] = false; mark(h, true); });
      changed();
      if (w.LuxireCart && LuxireCart.refresh) LuxireCart.refresh();
      return true;
    }).catch(function () {
      handles.forEach(function (h) { busy[h] = false; els(h).forEach(function (x) { x.classList.remove('is-busy'); say(x, 'Couldn’t add the swatch. Please try again.'); }); });
      changed();
      return false;
    });
  }
  function add(el) {
    var hadFocus = el.contains(d.activeElement);
    addAll([el]).then(function (ok) {
      if (ok && hadFocus) { var f = el.querySelector('[data-lx-sw-focus]'); if (f) f.focus(); }
    });
  }

  // The pill sits inside a product card (a link): its click adds the swatch and goes nowhere.
  d.addEventListener('click', function (e) {
    var t = e.target;
    var b = t.closest && t.closest('[data-lx-sw-add]');
    if (b) { e.preventDefault(); e.stopPropagation(); add(b.closest('[data-lx-sw]')); return; }
    var v = t.closest && t.closest('[data-lx-sw-view]');   // "View cart", or "✓ Swatch" on a card: the slide-out cart
    if (v) {
      if (w.LuxireCart && LuxireCart.open) { e.preventDefault(); e.stopPropagation(); LuxireCart.open(); }
      else if (v.tagName !== 'A') { e.preventDefault(); e.stopPropagation(); w.location.href = '/cart'; }
      return;
    }
    if (t.closest && t.closest('.lx-sw-pill')) { e.preventDefault(); e.stopPropagation(); }   // the message beside a pill isn't a link
  }, true);

  w.LXSwatch = { sync: sync, isSwatch: isSwatch, addAll: addAll, inCart: function (h) { return !!inCart[h]; } };
  function start() {
    if (!d.querySelector('[data-lx-sw]')) return;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(sync).catch(function () {});
  }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', start); else start();
})(window, document);
